import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['sidebar']

  switch () {
    if (this.sidebarTarget.style.display === 'block') {
      // noneで非表示
      this.sidebarTarget.style.display = 'none'
    } else {
      // blockで表示
      this.sidebarTarget.style.display = 'block'
    }
  }
}
